const scrollIntoView = (id: string, callback?: () => void) => {
  requestAnimationFrame(() => {
    try {
      const scrollContainerRef = document.querySelectorAll(id);
      scrollContainerRef?.item(scrollContainerRef.length - 1).scrollIntoView({ behavior: 'smooth' });
      callback?.();
    } catch (error) {
      console.error(error);
    }
  });
};

export default scrollIntoView;
